import React from "react";
import PropTypes from "prop-types";
import { Chip, Box, useTheme } from "@mui/material";
import { creditRequestStatusToColour, statusToLabel } from "../../util/creditRequestStatusMapping";
import { creditStatus } from "../../util/creditRequestMapping";

export default function StatusLabel(props) {
	const theme = useTheme();
	const isReviewing = props.status === creditStatus.reviewing;
	const backgroundColor = isReviewing
		? theme.palette.custom.creditRequest.reviewingBadge
		: creditRequestStatusToColour(props.status);

	return (
		<Box>
			<Chip
				label={statusToLabel(props.status)}
				size={props.size === "medium" ? "medium" : "small"}
				sx={{
					backgroundColor,
					border: isReviewing && theme.palette.mode === "dark" ? `1px solid ${theme.palette.text.primary}` : "none",
					color: "common.white",
				}}
			/>
		</Box>
	);
}

StatusLabel.propTypes = {
	status: PropTypes.string.isRequired,
	size: PropTypes.oneOf(["small", "medium"]),
};
